import { Injectable } from '@angular/core';
import { catchError, retry } from 'rxjs/internal/operators';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { GlobalSearchService } from '../services/globalsearchservice.service';

@Injectable({
	providedIn: 'root'
})

export class UsersService {
	key: string = 'UET6DFMPAXW7BKCB';
	config: any;
	user: any = [];
	package: any = '';

	constructor(private http: HttpClient, private _configSvc: RuntimeConfigLoaderService, public globalSearchService: GlobalSearchService) {
		this.globalSearchService.configsubscription.subscribe(r=>{
			this.config = r;
		})

		this.globalSearchService.user.subscribe((result) => {
			this.user = result;
		});

	}

	public httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
		})
	};



	public removeGroup(data: any) {
		var method = 'users/removegroup'
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('users', data))
		);
	}


	public addGroup(data: any) {
		var method = 'users/addgroup'
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('users', data))
		);
	}

	public updateGroup(data: any) {
		var method = 'users/updategroup'
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('users', data))
		);
	}

	public updateUserLocations(data: any) {
		var method = 'users/updatelocations'
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('users', data))
		);
	}

	public getNavState() {

		let navstate = JSON.parse(localStorage.getItem('navstate'));
		if(navstate == 'true' || navstate == true) {
			var tf = true;
		} else {
			var tf = false;
		}

		return tf;
	}
	public setNavState(inbound: boolean) {

		localStorage.setItem('navstate', JSON.stringify(inbound))
		return inbound;
	}

	public getLocalUser() {
		return JSON.parse(localStorage.getItem('user'));
	}

	public getUser(user) {
		var method = 'users/getuser&uid=' + user;
		return this.http.get(this.setEndPoint(method));
	}

	public updateUser(userid: any, data: any) {
		var method = 'users/update'
		return this.http.post(this.setEndPoint(method), { userid, data }, this.httpOptions).pipe(
			catchError(this.handleError('users', data))
		);
	}

	public createUser(userid: any, data: any) {
		var method = 'users/create'
		return this.http.post(this.setEndPoint(method), { userid, data }, this.httpOptions).pipe(
			catchError(this.handleError('users', data))
		);
	}

	public getUsers() {
		var method = 'users';
		return this.http.get(this.setEndPoint(method));
	}

	public getUserGroups() {
		var method = 'users/getusergroups';
		return this.http.get(this.setEndPoint(method));
	}

	public getUserGroup(id) {
		var method = 'users/getusergroup&gid=' + id;
		return this.http.get(this.setEndPoint(method));
	}


	private setEndPoint(method: any) {
		return this.getApi() + method + this.getApiKey()
	}

	private getApi() {
		return this.config.apiServer.endpoint;
	}

	private getApiKey() {
		return '&key=' + this.config.apiCredentials.clientId + '&userid=' + this.user.user.userid + this.getPackage();
	}

	private getPackage() {
		let p = this.globalSearchService.getSessionItem('package');
		if(p) {
			return '&package='+p;
		} else {
			return '';
		}
	}

	public getKey() {
		return '&apikey=' + this.key;
	}

	private handleError < T > (operation = 'operation', result ? : T) {
		return (error: any): Observable < T > => {
			return error;
		};
	}
}
